import { render, staticRenderFns } from "./info-record.vue?vue&type=template&id=8f9e6dde&scoped=true&"
import script from "./info-record.vue?vue&type=script&lang=js&"
export * from "./info-record.vue?vue&type=script&lang=js&"
import style0 from "./info-record.vue?vue&type=style&index=0&id=8f9e6dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9e6dde",
  null
  
)

export default component.exports